






import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ICheckoutCartOffer } from '@/interfaces/Checkout';

const CheckoutModule = namespace('App/Checkout');

@Component
export default class WPButton extends Vue {

  private observer: IntersectionObserver;

  private isIntersecting: boolean = false;

  @CheckoutModule.Getter('selectedOffer')
  private offer!: ICheckoutCartOffer;

  private get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get offerTitle(): string {
    return (this.offer && this.offer.display_name) || '';
  }

  private get showPaymentButtonOF(): boolean {
    return this.isMobile && this.$route.query.of === '1';
  }

  private get href(): string {
    const phone = '5511973431646';
    const message = `Olá! Gostaria de mais informações sobre o produto *${this.offerTitle}*! ${location.href}`;

    return `https://api.whatsapp.com/send?1=pt_BR&phone=${phone}&text=${message}`;
  }

  private get showMargin() {
    return this.isMobile && this.showPaymentButtonOF && !this.isIntersecting;
  }

  private handleIntersect(entry: IntersectionObserverEntry) {
    const isIntersecting = entry.isIntersecting;
    return isIntersecting ? this.isIntersecting = true : this.isIntersecting = false;
  }

  mounted () {
    const customTemplateId = document.querySelector('#customTemplate');

    if (customTemplateId) {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          this.handleIntersect(entry);
        });
      });

      this.observer.observe(customTemplateId as HTMLElement);
    }
  }
}
